import {operation, Service} from '@iiiristram/sagun'
import {catchWith} from '@logistics-frontend/client-core/utils/sagun'
import {retry} from '@logistics-frontend/core/sagas/retry'
import {noop} from '@logistics-frontend/utils'
import {requestMeta} from '@yandex-int/ymaps3-react/deprecated'
import {Props as MapComponentProps} from '@yandex-int/ymaps3-react/deprecated/MapComponent/MapComponent'
import {all, call} from 'typed-redux-saga'

type VectorCustomization = NonNullable<MapComponentProps['customization']>

const deprecatedVectorEngineLoader = () => {
  return import(/* webpackChunkName: 'deprecated-vector-engine' */ '@yandex-int/ymaps3-react/deprecated/vector')
}
const customizationStyleLoader = (): Promise<VectorCustomization> => {
  return import(/* webpackChunkName: 'customization-day-style' */ './YandexMap.customization-day-style.json').then(
    r => r.default,
  )
}

export class YandexMapService extends Service {
  toString() {
    return 'YandexMapService'
  }

  @operation
  @catchWith(noop)
  @retry({retries: 5, delay: 150})
  *load(lang: string) {
    const {meta, vectorEngine, customization} = yield* all({
      meta: call(requestMeta, lang),
      vectorEngine: call(deprecatedVectorEngineLoader),
      customization: call(customizationStyleLoader),
    })

    return {
      meta,
      customization,
      vectorEngineLoader: () => Promise.resolve(vectorEngine),
    }
  }
}
